"use strict";

const template = document.createElement("template");
template.innerHTML = require("./template");

const HOW_MANY_PAGES = 7;
const DOTS = "...";
const PREVIOUS_NEXT = require("./previous_next");
const DEFAULT_PAGE = 1;

class Pagination extends HTMLElement {

    constructor() {
        super();

        this._shadowRoot = this.attachShadow({ mode: 'open' });
        this._shadowRoot.appendChild(template.content.cloneNode(true));

        this.ul = this._shadowRoot.querySelector("ul");
        this.perPage = this._shadowRoot.querySelector("swiftref-dropdown");
        this.pages = [];

    }

    connectedCallback() {
        this.ul.addEventListener("click", this.onPaginationClick.bind(this));


        if (this.per_page) {
            this.perPage.setAttribute("value", this.per_page);
            this.perPage.addEventListener("change", function (event) {

                event.preventDefault();
                event.stopPropagation();

                let perPage;
                try {
                    perPage = parseInt(event.detail.value, 10);
                } catch (e) {
                    perPage = event.detail.value;
                }

                this.dispatchEvent(new CustomEvent("change", {
                    detail: {
                        per_page: perPage
                    },
                    bubbles: true,
                    composed: true
                }));

                // this.per_page = perPage;


            }.bind(this));
        } else {
            this.perPage.parentNode.style.display = "none";
        }




    }


    disconnectedCallback() {
        this.ul.removeEventListener("click", this.onPaginationClick.bind(this));
    }

    static get observedAttributes() {
        return ["last_page", "current_page", "per_page", "disabled"];
    }

    attributeChangedCallback (name, oldValue, newValue) {
        this.pages = this.calculatePagesRange(this.last_page);
        this.render();

        if (name === "per_page") {
            this.perPage.value = newValue;
        }
    }

    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(disabled) {
        this.setAttribute("disabled", "disabled");
    }
    get per_page() {
        return parseInt(this.getAttribute("per_page"), 10);
    }
    set per_page(per_page) {
        this.setAttribute("per_page", per_page);
    }
    get last_page() {
        return parseInt(this.getAttribute("last_page"), 10);
    }
    set last_page(last_page) {
        this.setAttribute("last_page", last_page);
    }
    get current_page() {
        return parseInt(this.getAttribute("current_page"), 10) || DEFAULT_PAGE;
    }
    set current_page(current_page) {
        this.setAttribute("current_page", current_page);
    }

    onPaginationClick (event) {

        if (this.disabled) {
            return;
        }

        var target = event.target;

        if (target.tagName === "I") {
            target = target.parentNode;
        }

        if (target.tagName === "LI" && !target.classList.contains("disabled") && !target.classList.contains("current")) {
            this.current_page = target.value;
            this.dispatchEvent(new CustomEvent("change", {
                detail: {
                    current_page: this.current_page
                },
                bubbles: true,
                composed: true
            }));
        }

    }
    /**
     * Given the lastPage, returns an array with the pages to be displayed
     * ("..." after the page 1 and before lastPage included)
     *
     * @param {number} lastPage
     * @returns {Array.string} pagesRange array of string
     * @author Simone Sacchi, Francesco Zanoni
     * @version 2017/07/10
     */
    calculatePagesRange (lastPage) {

        const pagesRange = [];
        let firstCalculatedPage;
        let lastCalculatedPage;

        if ((this.current_page - Math.floor(HOW_MANY_PAGES / 2)) >= 1 && (this.current_page + Math.floor(HOW_MANY_PAGES / 2)) <= lastPage) {
            firstCalculatedPage = this.current_page - Math.floor(HOW_MANY_PAGES / 2);
            lastCalculatedPage = this.current_page + Math.floor(HOW_MANY_PAGES / 2);
        } else if ((this.current_page - Math.floor(HOW_MANY_PAGES / 2)) < 1 && (this.current_page + Math.floor(HOW_MANY_PAGES / 2)) > lastPage) {
            firstCalculatedPage = 1;
            lastCalculatedPage = lastPage;
        } else if ((this.current_page - Math.floor(HOW_MANY_PAGES / 2)) < 1) {
            firstCalculatedPage = 1;
            lastCalculatedPage = HOW_MANY_PAGES;
        } else if ((this.current_page + Math.floor(HOW_MANY_PAGES / 2)) > lastPage) {
            firstCalculatedPage = lastPage + 1 - HOW_MANY_PAGES;
            lastCalculatedPage = lastPage;
        }

        // last page must be always the last (the above algorithm may have some glitch)
        if (lastCalculatedPage > lastPage) {
            lastCalculatedPage = lastPage;
        }
        // do not allow zero or negative values
        if (firstCalculatedPage < 1) {
            firstCalculatedPage = 1;
        }

        // prepend the firstPage and the "..."
        if (firstCalculatedPage !== 1) {
            pagesRange.push(1);
            pagesRange.push(DOTS);
        }

        for (var i = firstCalculatedPage; i <= lastCalculatedPage; i ++) {
            pagesRange.push(i);
        }

        // append the lastPage and the "..."
        if (lastPage !== lastCalculatedPage) {
            pagesRange.push(DOTS);
            pagesRange.push(lastPage);
        }

        return pagesRange;

    }

    resetUi () {

        this.ul.innerHTML = PREVIOUS_NEXT;
    }

    render() {

        this.resetUi();

        if (this.pages) {
            for (let i = 0; i < this.pages.length; i ++) {
                const li = document.createElement("li");
                const pageNumber = this.pages[i];
                li.innerText = pageNumber;

                if (pageNumber === this.current_page) {
                    li.className = "current";
                }
                if (pageNumber === DOTS) {
                    li.classList.add("disabled");
                } else {
                    li.value = pageNumber;
                }
                this.ul.insertBefore(li, this.ul.children[i + 1]);
            }

            // disable the previous button
            if (this.current_page === 1) {
                this.ul.children[0].classList.add("disabled");
            } else {
                this.ul.children[0].classList.remove("disabled");
                this.ul.children[0].value = this.current_page - 1;
            }
            // disable the next button
            if (this.current_page === this.last_page) {
                this.ul.children[this.ul.children.length - 1].classList.add("disabled");
            } else {
                this.ul.children[this.ul.children.length - 1].classList.remove("disabled");
                this.ul.children[this.ul.children.length - 1].value = this.current_page + 1;
            }

        }

    }


}

window.customElements.define("swiftref-pagination", Pagination);

module.exports = Pagination;
